import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { NavLink, useNavigate } from 'react-router-dom';
import Accordion from 'react-bootstrap/cjs/Accordion';
import { rootStore } from '../../../../model/RootStoreContext';
import { ICategory } from '../../../../model/category/Category';
import { sortByString } from '@yakoffice/yakoffice-firebase';
import {
    useAddKindLink,
    useGetAddSubCategoryLink,
    useGetCategoryLink,
    useGetEntitiesLink,
    useGetKindLink
} from '../../../routes';
import { ClaimType, KindStatus } from '@yakoffice/publisher-types';
import { Button, Dropdown } from 'react-bootstrap';
import styles from './categoryNavigationAccordian.module.sass';
import DropdownButton from 'react-bootstrap/DropdownButton';

interface CategoryAccordionPropsType {
    currentCategory: ICategory | null,
    category: ICategory,
    allCategories: ICategory[],
    expandAll?: boolean,
    isParentCategory: boolean;
    filterArchived: boolean;
}

export const CategoryNavigationAccordion: FC<CategoryAccordionPropsType> = observer((props) => {

    const [defaultExpanded, setDefaultExpanded] = useState<ICategory>();
    const [expand, setExpand] = useState(!!props.expandAll);
    const [expandChildren, setExpandChildren] = useState(!!props.expandAll);
    const getCategoryLink = useGetCategoryLink();
    const getAddSubCategoryLink = useGetAddSubCategoryLink();
    const getAddKindLink = useAddKindLink();
    const getKindLink = useGetKindLink();
    const getEntitiesLink = useGetEntitiesLink();
    const navigator = useNavigate();

    useEffect(() => {
        if (props.currentCategory) {
            setDefaultExpanded(props.currentCategory);

            if (props.currentCategory.id === props.category.id)
                setExpand(true);

            if (props.currentCategory.parent?.id === props.category.id) {
                setDefaultExpanded(props.currentCategory.parent);
                setExpand(true);
            }
        }
    }, [props.currentCategory, props.category]);

    useEffect(() => {
        setExpand(!!props.expandAll);
        setExpandChildren(!!props.expandAll);
    }, [props.expandAll]);


    const accordionProps = () => {
        return {
            activeKey: expand ? JSON.stringify(props.category?.id) : '',
            defaultActiveKey: props.currentCategory ? JSON.stringify(defaultExpanded?.id) : ''
        };
    };
    return (
        <li className={styles.folder}>

            <Accordion {...accordionProps()}>


                <div className={styles.categoryLinkWrapper}>
                    <Button onClick={() => setExpand(!expand)}
                            className={`${styles.categoryToggle} ${styles.categoryLink} ${props.currentCategory?.parent?.id === props.category.id && 'active'} ${props.category.status.toLowerCase()}`}>
                        <i className={`fas ${expand ? 'fa-caret-down' : 'fa-caret-right'} me-2`} />
                        <i className={`fa ${expand ? 'fa-folder-open' : 'fa-folder'} me-2`} />
                        {/*{camelToTitle(props.category.name)}*/}
                        {props.category.name}
                    </Button>
                    {(rootStore.authStore.currentAuthUser.hasProjectClaim(ClaimType.EditCategory) || rootStore.authStore.currentAuthUser.hasProjectClaim(ClaimType.EditKind)) &&

                        <DropdownButton variant="link" className={styles.catDropdown}
                                        title={<i className="fas fa-ellipsis-v float-end text-gray-700" />}>
                            {props.isParentCategory && rootStore.authStore.currentAuthUser.hasProjectClaim(ClaimType.EditCategory) &&
                                <Dropdown.Item as="button"
                                               onClick={() => navigator(getAddSubCategoryLink({ categoryId: props.category.id }))}>
                                    Add sub-category
                                </Dropdown.Item>}
                            {rootStore.authStore.currentAuthUser.hasProjectClaim(ClaimType.EditKind) &&
                                <Dropdown.Item as="button"
                                               onClick={() => navigator(getAddKindLink({ categoryId: props.category.id }))}>Add
                                    kind
                                </Dropdown.Item>
                            }
                            <Dropdown.Divider />
                            {rootStore.authStore.currentAuthUser.hasProjectClaim(ClaimType.EditCategory) &&
                                <Dropdown.Item
                                    onClick={() => navigator(getCategoryLink({ categoryId: props.category.id }))}
                                    as="button"
                                    className={styles.catDropdownSettings}>
                                    <i className="fas fa-cog" /> Edit
                                </Dropdown.Item>
                            }
                        </DropdownButton>
                    }
                </div>

                <Accordion.Collapse eventKey={JSON.stringify(props.category.id)} className={''}>
                    <ul>

                        {props.allCategories.slice().sort(sortByString('name')).map((subCategory: ICategory) => {
                            if (subCategory.parent && subCategory.parent.id === props.category.id)
                                return (
                                    <CategoryNavigationAccordion key={`subCategory-${subCategory.id}`}
                                                                 currentCategory={props.currentCategory}
                                                                 category={subCategory}
                                                                 allCategories={rootStore.categoryStore.categories}
                                                                 expandAll={expandChildren}
                                                                 isParentCategory={false}
                                                                 filterArchived={props.filterArchived} />
                                );
                            else
                                return null;
                        })}

                        {props.category.kinds
                            .slice()
                            .sort(sortByString('name'))
                            .filter(kindVersion => !props.filterArchived || kindVersion.kindStatus !== KindStatus.Archived)
                            .map(kindVersion => {

                                const kindLink = kindVersion.isSpecificationForKinds
                                    ? getKindLink({ categoryId: props.category.id, kindId: kindVersion.kindId })
                                    : getEntitiesLink({ categoryId: props.category.id, kindId: kindVersion.kindId });

                                return (
                                    <li key={`kind-${kindVersion.id}`}>
                                        {/*<NavLink to={kindLink} className={styles.categoryLink}>{camelToTitle(kindVersion.name)}</NavLink>*/}
                                        <NavLink to={kindLink} className={styles.categoryLink}
                                                 onDoubleClick={() => navigator(getKindLink({
                                                     categoryId: props.category.id,
                                                     kindId: kindVersion.kindId
                                                 }))}>{kindVersion.name}</NavLink>
                                    </li>
                                );
                            })}
                    </ul>
                </Accordion.Collapse>
            </Accordion>
        </li>
    );
});
